import NewLookTheme from 'web-app/styleguide/themes/new-look';

export const COHORT_COLORS = [
    NewLookTheme.analogue3,
    NewLookTheme.accent2,
    NewLookTheme.active,
    NewLookTheme.accent3,
    NewLookTheme.primary,
    NewLookTheme.accent1,
    NewLookTheme.text,
    NewLookTheme.analogue1,
    NewLookTheme.analogue2,
    NewLookTheme.analogue4,
];

export const MAX_COHORTS = COHORT_COLORS.length;
export const ALL_CHILDREN_ID = 'ALL_CHILDREN_ID';

export enum CHART_FILTER {
    ALL_AREAS = '',
    PRIME_AREAS = 'PRIME_AREAS',
}
